import { useState } from 'react';
import { useAuth } from '../lib/auth.js';

export default function SignInScreen() {
  const { signIn } = useAuth();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy]         = useState(false);
  const [err, setErr]           = useState('');

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setErr('');
    try {
      await signIn(email.trim(), password);
    } catch (e) {
      setErr(e.message || 'Could not sign in.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="hb-signin">
      <div className="hb-signin__card">
        <div className="hb-signin__sticker">MEMBERS ONLY</div>
        <h1 className="hb-signin__title">Welcome to the store.</h1>
        <p className="hb-signin__sub">
          Home Blockbuster is a private video club. Sign in with your member email and password.
          If you don't have an account, ask Mike for one.
        </p>
        <form onSubmit={onSubmit} className="hb-signin__form">
          <label>
            Email
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
            />
          </label>
          <label>
            Password
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          {err && <div className="hb-signin__err">{err}</div>}
          <button type="submit" disabled={busy} className="hb-signin__btn">
            {busy ? 'Checking your card…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
